<!-- ExtraiDadosBasico.svelte -->
<script>
  import { onMount } from 'svelte';
  import Conexoes from '../../Classes/Conexoes.js';
  import ExibeItem from '../../Classes/exibeItem.js';
  import CelulasDeExtracaoDados from './Celulas/CelulasDeExtracaoDados.svelte';
  import Loading from '../../componentes_basicos/Loading.svelte';
    import LoadingTela from '../../componentes_basicos/LoadingTela.svelte';

  
  export let navegacao;
  export let api;
  export let parametros;
  export let celulas;
  export let tabela;
  export let podeDeletar;
  let carregando=false;
 let conexoes = new Conexoes();
  let dados = [];
  let paginaAtual = 1;
  const tamanhoPagina =10;
  let loading = false;

  export async function conectar(apaga=false) { 
    if(apaga){
      dados=[];
      paginaAtual=1;
    }
   conexoes = new Conexoes();
    carregando = true;
   
      const parametrosComPaginacao = {
        ...parametros,
        posicao: (paginaAtual - 1) * tamanhoPagina,
        tamanho: tamanhoPagina
      };
      const novosDados = await conexoes.conecta(api, parametrosComPaginacao);
      // Adiciona os novos dados à lista existente
      dados = [...dados, ...novosDados];
      console.log(dados);
      console.log(parametrosComPaginacao)
      loading = false;
    
     
      loading = false;
   
      carregando = false; // Esconde o ícone de carregamento quando terminar
   
  }

  // Conectar ao carregar o componente
  onMount(conectar);

  // Função para carregar mais dados quando o scroll atinge o fim
  function handleScroll() {
    const { scrollTop, clientHeight, scrollHeight } = document.querySelector('.card');
    if (scrollTop + clientHeight >= scrollHeight - 70 && !loading) {
      loading = true;
      paginaAtual++;
      conectar();
    }
  }

</script>
<Loading isLoading={carregando}/>
{#if paginaAtual==1}
  <LoadingTela isLoading={carregando} />
  {/if}
{#if dados.length > 0} 

  <div class="card" on:scroll={handleScroll}>
   
    <table>
      {#each dados as linha}
        <tr>
          <td>
            <CelulasDeExtracaoDados {linha} {celulas} {tabela} {podeDeletar} id={linha.id} {navegacao}/>
          </td>
        </tr>
      {/each}
    </table>
    
  </div>
  
 
{:else if !carregando}
  <h2 class='card branco'>Nenhum dado encontrado.</h2>
{/if}

<style>
  .card {
     /* Altura da tela inteira */
    overflow-y: auto; /* Adiciona scroll vertical se necessário */
    border: 1px solid #ccc; /* Contorno sombreado */
    border-radius: 5px; /* Borda arredondada */
    padding: 5px; /* Espaçamento interno */

    background-color:  transparent; }
  .branco{
    color:orange;
  }
</style>
